import * as moment from 'moment';
import { FormEditor } from './../../models/editors/form-editor.base.model';

export class DateTimePicker extends FormEditor<moment.Moment> {
    controlType = 'datetimepicker';

    constructor(options: {} = {}) {
        super(options);
    }
}
